import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';

export function ExperimentPoster(props) {
  return (
    <Image
      draggable={false}
      className={props.className}
      src={props.image}
      alt={props.altText}
      style={props.style}
    />
  );
}

ExperimentPoster.propTypes = {
  /**
   * ClassName for component
   */
  className: PropTypes.string,

  altText: PropTypes.string
};

ExperimentPoster.defaultProps = {
};
